// extracted by mini-css-extract-plugin
module.exports = {"productInfoContainer":"BRghoJ","imageContainer":"c6ALfui","productImage":"c9iDlCh","brandDesktop":"SA5nkL","productTitle":"Z5H6D3","brandMobile":"whpjqH"};